module.exports = __webpack_public_path__ + "static/media/news_5.a0788ffa.png";